import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { getTrackerHistory } from '../../../../../redux/features/tutorReplacementTrackerSlice';
import { PROGRESS_LABEL } from '../utils/trackerConstants';

const LOG_ACTION = { ASSIGNED: 1, PROGRESS: 2 };

// Assignments and progress updates for one replacement, latest first. `refreshKey` reloads it after a save.
export default function TrackerHistory({ trainerAssignmentId, refreshKey = 0 }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!trainerAssignmentId) return;
    setLoading(true);
    dispatch(getTrackerHistory(trainerAssignmentId)).then((action) => {
      setRows(action.payload?.status === 'success' ? action.payload.data ?? [] : []);
      setLoading(false);
    });
  }, [dispatch, trainerAssignmentId, refreshKey]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={2}>
        <CircularProgress size={24} />
      </Box>
    );
  }
  if (!rows.length) {
    return (
      <Typography variant="body2" color="text.secondary" py={1}>
        No updates yet
      </Typography>
    );
  }

  return (
    <Stack gap={1}>
      {rows.map((row) => (
        <Box key={row.id} sx={{ borderLeft: '3px solid', borderColor: 'primary.light', pl: 1.5, py: 0.5 }}>
          <Typography variant="subtitle2">
            {row.action === LOG_ACTION.ASSIGNED
              ? `Assigned to ${row.assignedToName ?? '—'}`
              : `Progress: ${PROGRESS_LABEL[row.progressStatus] ?? '—'}`}
          </Typography>
          {row.remarks ? <Typography variant="body2">{row.remarks}</Typography> : null}
          <Typography variant="caption" color="text.secondary">
            {row.createdByName ?? '—'} · {dayjs(row.createdAt).format('DD-MM-YYYY hh:mm A')}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
